import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=5f1937d7&"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=js&"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports